var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveAsBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4FDD\u5B58\u4E3A\u533A\u5757") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-1063.000000, -255.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u884C\\u5BB9\\u5668-sel",
    transform: "translate(352.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4FDD\\u5B58\\u4E3A\\u533A\\u5757",
    transform: "translate(711.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.01,
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2178431,7.4669886 L11.2171569,9.9660114 L13.7178431,9.9669886 L13.7178431,10.9669886 L11.2171569,10.9660114 L11.2178431,13.4669886 L10.2178431,13.4669886 L10.2171569,10.9660114 L7.71784309,10.9669886 L7.71784309,9.9669886 L10.2171569,9.9660114 L10.2178431,7.4669886 L11.2178431,7.4669886 Z M11.6535293,0.533011403 C12.4332254,0.533011403 13.0739779,1.12789949 13.1466627,1.88855139 L13.1535293,2.0330114 L13.1535293,5.97382453 L12.1535293,5.97382453 L12.1535293,2.0330114 C12.1535293,1.78755151 11.9766541,1.58340303 11.7434049,1.54106707 L11.6535293,1.5330114 L1.78215691,1.5330114 C1.53669702,1.5330114 1.33254854,1.70988656 1.29021258,1.94313577 L1.28215691,2.0330114 L1.28215691,11.9043838 C1.28215691,12.1498436 1.45903207,12.3539921 1.69228128,12.3963281 L1.78215691,12.4043838 L7.79010871,12.4043838 L7.79010871,13.4043838 L1.78215691,13.4043838 C1.00246079,13.4043838 0.361708233,12.8094957 0.289023489,12.0488438 L0.282156911,11.9043838 L0.282156911,2.0330114 C0.282156911,1.25331529 0.877044994,0.612562725 1.6376969,0.539877981 L1.78215691,0.533011403 L11.6535293,0.533011403 Z M7.25473991,7.08783701 L7.25473991,8.08783701 L3.16339973,8.08783701 L3.16339973,7.08783701 L7.25473991,7.08783701 Z M10.2722864,3.63520029 L10.2722864,4.63520029 L3.16339973,4.63520029 L3.16339973,3.63520029 L10.2722864,3.63520029 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAsBlock);
export default __webpack_public_path__ + "static/media/save-as-block.63c2d417.svg";
export { ForwardRef as ReactComponent };